// extracted by mini-css-extract-plugin
export default {"vars":"'styles/vars.module.css'","phone":"480px","tablet-max":"1199px","container":"container_container__EnVfl"};